import {smootherSetup, smoother} from '../Utility/scroll-smoother.js';

document.addEventListener('DOMContentLoaded', (event) => {
  const body = document.querySelector('body');
  const nav = document.querySelector('.main-navigation');
  const menuToggle = nav.querySelector('.menu-toggle');

  // open/close mobile nav
  function toggleNav() {
    // Set Active Class
    nav.classList.toggle('mobile-active');
    menuToggle.classList.toggle('active');
    body.classList.toggle('scroll-lock');
    body.classList.toggle('mobile-nav');
    smoother.kill();
  }

  // close mobile nav (for resizing event)
  function closeNav() {
    nav.classList.remove('mobile-active');
    menuToggle.classList.remove('active');
    body.classList.remove('scroll-lock');
    body.classList.remove('mobile-nav');
    smootherSetup();
  }

  if( nav ) {
    menuToggle.addEventListener('click', (e) => {
      e.preventDefault();
      toggleNav();
    });

    nav.querySelectorAll('a').forEach((el)=> {
      el.addEventListener('click', closeNav);
    });

    // mobile dropdown item
    const mobileDropdownItem = nav.querySelectorAll('.dropdown-item > a');
    mobileDropdownItem.forEach(item => {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        this.parentNode.classList.toggle('dropdown-open');
      });
    });

    // set menu state on load and resize if changing from mobile to desktop
    function set_menu_state() {
      // check if the menu toggle is visible
      const isDesktop = window.getComputedStyle(menuToggle, null).visibility == "hidden" ? true : false;
      
      if(isDesktop) {
        // close nav
        closeNav();
      }
    }
    set_menu_state();

    // Resize modals on window resize
    window.addEventListener('resize', (e) => {
      set_menu_state();
    });

  }

});